export const REQUEST_HOME_INFO_CARDS = "REQUEST_HOME_INFO_CARDS";
